import { createContext } from "react";

const studyReportContext = createContext();

export default studyReportContext;